export default __webpack_public_path__ + "media/src/features/home-page-redesign/assets/bgMouseGrey-0f5acb374cadceddb12131b22c4d28ca.svg";